import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        /* UI */
        this.$list = this.$('list')[0]
        this.$items = this.$('item')
    }

    init() {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        const category = searchParams.get("category") || 'all';
        const $targetItem = [...this.$items].find($item => $item.dataset.id === category)

        if ($targetItem) {
            this.$list.scrollTo({
                left: $targetItem.offsetLeft
            })
        }
    }
}
